import { jsxs as a, jsx as e } from "react/jsx-runtime";
import { Root as k, Trigger as N, Portal as z, Overlay as M, Content as R, DialogTitle as B } from "@radix-ui/react-dialog";
import l from "react";
import H from "classnames";
import o from "./index.es5729.js";
import { useTheme as U } from "./index.es190.js";
import { focusFirstElement as $ } from "./index.es553.js";
import { useScreenZoomSize as h } from "./index.es589.js";
import { LoadingBar as j } from "./index.es69.js";
const w = "1000px", P = "493px", W = 3, Q = ({
  trigger: d,
  children: f,
  hasBackdrop: u,
  open: n,
  onOpenChange: t,
  testId: r,
  isLoading: i,
  fullSize: y,
  modalTitle: T,
  disableClickOutside: c,
  size: v = "default",
  overlayOffset: _ = W,
  backdropElevation: A = 100,
  maxHeight: D = P,
  maxWidth: E = w
}) => {
  const m = l.useRef(null), { shadows: b } = U().activeTheme.theme, p = h(), F = l.useCallback(() => {
    t == null || t(!0);
  }, [t]), L = l.useCallback(
    (s) => {
      c ? s.preventDefault() : t == null || t(!1);
    },
    [t, c]
  ), S = l.useCallback((s) => {
    s.preventDefault(), setTimeout(() => {
      $(m);
    }, 100);
  }, []), x = H(o.dialogContent, {
    [o.fullSize]: y,
    [o.smallSize]: v === "small",
    [o.hasLoading]: i,
    [o.fullZoomLayout]: p === "max"
  });
  return /* @__PURE__ */ a(k, { open: n, onOpenChange: t, children: [
    /* @__PURE__ */ e(N, { asChild: !0, onClick: F, "data-testid": `${r}-trigger`, children: d }),
    /* @__PURE__ */ a(z, { children: [
      u && /* @__PURE__ */ e(
        M,
        {
          className: o.dialogOverlay,
          style: {
            backgroundColor: b.backdrop[A],
            "--overlay-offset": _
          },
          "data-testid": `${r}-overlay`
        }
      ),
      /* @__PURE__ */ e("div", { className: o.dialogContentWrapper, children: /* @__PURE__ */ a(
        R,
        {
          ref: m,
          "aria-labelledby": "modal-title",
          onPointerDownOutside: L,
          className: x,
          "data-testid": `${r}-content`,
          style: {
            maxWidth: E,
            maxHeight: D
          },
          onOpenAutoFocus: S,
          children: [
            /* @__PURE__ */ e(B, { style: { visibility: "hidden" }, children: T }),
            f,
            i && /* @__PURE__ */ e("div", { className: o.loaderContainer, children: /* @__PURE__ */ e(j, {}) })
          ]
        }
      ) })
    ] })
  ] });
};
export {
  Q as BaseModal,
  w as DEFAULT_BASE_MODAL_MAX_WIDTH,
  P as DEFAULT_MAX_HEIGHT
};
//# sourceMappingURL=index.es872.js.map
